import Vue from 'vue'
import goalEdit from './goaledit.js'
import { levelToAttributeNames } from '@/util/goals'
import { goalSectionsPayload } from '@/util/goal_sections'

var customGoalState = {
  namespaced: true,
  state: {
    goalContentPageUuid: null,
    goalTextMap: {},
    goalLevelsTweaked: {}, // boolean map indicating which goal levels have been tweaked
    goalSections: null,
    goalFormat: null,
    libraryGoalUuid: null // this is set for an existing saved goal, null if we're tweaking a goal content page "from scratch" outside the library
  },
  mutations: {
    setGoalContentPageUuid(state, uuid) {
      state.goalContentPageUuid = uuid
    },

    /* payload should have two attributes: level and text */
    setGoalText(state, payload) {
      Vue.set(state.goalTextMap, payload.level, payload.text)
    },
    resetGoalText(state, payload) {
      Vue.set(state.goalTextMap, payload.level, payload.text)
      Vue.set(state.goalLevelsTweaked, payload.level, false)
    },

    setGoalSections(state, { sections, format }) {
      state.goalSections = sections || null
      state.goalFormat = format || null
    },
    setLevelTweaked(state, level) {
      Vue.set(state.goalLevelsTweaked, level, true)
    },
    setLibraryGoalUuid(state, savedGoalUuid) {
      state.libraryGoalUuid = savedGoalUuid
    }
  },
  actions: {
    // should be called when the goal content page being worked with is changed/updated (i.e. viewing a new goal content page)
    initializeCustomGoal(context, { contentUuid, primaryGoalText, adaptedGoalsArray, goalSections, goalFormat }) {
      context.commit('setGoalContentPageUuid', contentUuid)
      context.commit('setGoalText', { level: 'grade', text: primaryGoalText })
      context.commit('setGoalSections', { sections: goalSections, format: goalFormat })
      adaptedGoalsArray.forEach(adaptedGoal => {
        context.commit('setGoalText', { level: adaptedGoal.level, text: adaptedGoal.text })
      })
    },
    goalTextEdited(context, { level, text }) {
      context.commit('setGoalText', { level, text })
      context.commit('setLevelTweaked', level)
    }
  },
  getters: {
    // payload doesn't include student info; caller needs to provide info
    savedGoalPayload(state, getters, rootState, rootGetters) {
      let payload = {
        goal_uuid: state.goalContentPageUuid,
        user_uuid: rootState.user.user.uuid,
        personalized: Object.values(state.goalLevelsTweaked).some(tweaked => tweaked),
        ...goalSectionsPayload(state.goalSections, state.goalFormat)
      }

      Object.keys(state.goalTextMap)
        .filter(level => state.goalLevelsTweaked[level])
        .forEach(level => {
          let attr = levelToAttributeNames[level]
          payload[attr] = state.goalTextMap[level]
        })

      return payload
    },
    levelToAttributeNames() {
      return levelToAttributeNames
    }
  }
}

customGoalState.state = Object.assign(goalEdit.state, customGoalState.state)
customGoalState.mutations = Object.assign(goalEdit.mutations, customGoalState.mutations)

export default customGoalState
